export const FUNCTION_WHITELIST = new Set([
    'sum',
    'avg',
    'min',
    'max',
    'count',
    'length',
    'upper',
    'lower',
    'trim',
    'now',
]);
export const RESERVED_VARIABLES = new Set(['_now']);
export const VARIABLE_NAME_REGEX = /^[a-z][a-z0-9_]{0,31}$/;
export function isValidVariableName(name) {
    return VARIABLE_NAME_REGEX.test(name);
}
export function isReservedVariableName(name) {
    return RESERVED_VARIABLES.has(name);
}
